/**
 * Created by user on 2020/5/29.
 */

import { textMap4 } from '../util/map';

export { textMap4 as textMap }

export default textMap4
